import { render, staticRenderFns } from "./ResultTab.vue?vue&type=template&id=99f8312c"
import script from "./ResultTab.vue?vue&type=script&lang=js"
export * from "./ResultTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f8312c')) {
      api.createRecord('99f8312c', component.options)
    } else {
      api.reload('99f8312c', component.options)
    }
    module.hot.accept("./ResultTab.vue?vue&type=template&id=99f8312c", function () {
      api.rerender('99f8312c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/lottery/components/ResultTab.vue"
export default component.exports